import DiscountCouponForm from '../../features/commonfile/DiscountCouponForm'

const AdminDiscountCouponCodePage = () => {
    return (
        <DiscountCouponForm />
    )
}

export default AdminDiscountCouponCodePage